import React from 'react';
import FormWidget from '../../../form/FormWidget';
import { useI18n } from '../../../i18n/I18n';
import { SCHEDULE_FORM_WIDGET_FIELD_NAMES } from '../constants';
import useScheduleFormWidgetContext from '../useScheduleFormWidgetContext';
import { resolveStateFieldName } from '../utils/form-utils';

export interface ScheduleNameFormWidgetProps {
    name?: string;
    disabled?: boolean;
}

export default function ScheduleNameFormWidget({
    name: nameProp,
    disabled: disabledProp = false
}: ScheduleNameFormWidgetProps) {
    const t = useI18n();

    const {
        loading,
        disabled,
        nameFormFieldLabelToken = 'scheduleFormWidget.name.label'
    } = useScheduleFormWidgetContext();

    const name = resolveStateFieldName([nameProp, SCHEDULE_FORM_WIDGET_FIELD_NAMES.ITEM_NAME]);

    const isWidgetDisabled = disabled || disabledProp || loading;

    return <FormWidget label={t(nameFormFieldLabelToken)} name={name} disabled={isWidgetDisabled} />;
}
